const YEAR_IN_MS = 365 * 24 * 60 * 60 * 1000;
const AFFISE_COOKIE_NAME = "aff_ref_data";
const AFFISE_COOKIE_DOMAIN = ".lunaro.ru";

const writeAffiseData = (queryString: string) => {
  if (!queryString) return;

  const expiresAt = new Date(Date.now() + YEAR_IN_MS).toUTCString();
  document.cookie = `${AFFISE_COOKIE_NAME}=${queryString};expires=${expiresAt};path=/;domain=${AFFISE_COOKIE_DOMAIN};Secure;SameSite=Strict`;
};

export const applyAffiseTrackingFromUrl = () => {
  if (typeof window === "undefined" || typeof document === "undefined") return;

  const decodedSearch = decodeURIComponent(window.location.search.substring(1));
  if (!decodedSearch.includes("clickid")) return;

  const queryString = window.location.href.split("?")[1] || "";
  writeAffiseData(queryString);
};
